<template>
  <card>

  </card>
</template>
<script>

export default {
  name: "quit",
  mounted() {
    localStorage.removeItem('token');
    //localStorage.removeItem('root');
    localStorage.removeItem('shop');
    //localStorage.removeItem('bid');
    this.$http.defaults.headers.common["Authorization"] = null;
    // this.$http.defaults.headers.common["bid"] = null;
    //this.$http.defaults.headers.common["root"] =null;
    this.$http.defaults.headers.common["shop"] = null;

    this.$store.dispatch("setUser", null);
    //this.$store.dispatch("setBusiness", null);
    //this.$store.dispatch("setRoot", null);
    this.$store.dispatch("setShop", null);
    setTimeout(() => {
      this.$router.push('/dashboard');
    }, 100);
  },
};
</script>
<style>
</style>
